import { utils, writeFileXLSX } from 'xlsx'
import { format } from 'date-fns'

export const exportTableDataToXlsx = (rootSelector, project, filename) => {
  const tHeaderSelector = document.querySelector(`${rootSelector} .ant-table-header table`)
  const tBodySelector = document.querySelector(`${rootSelector} .ant-table-body table`)

  let headerWorksheet = utils.table_to_sheet(tHeaderSelector)
  let headerData = utils.sheet_to_json(headerWorksheet, { header: 1 })

  let worksheet = utils.table_to_sheet(tBodySelector, { raw: true, origin: 'A6' })

  exportReportDate(worksheet)
  project && exportReportProject(worksheet, project)

  exportWorksheetToXlsx(worksheet, headerData, filename)
}

export const exportRowsToXlsx = (rows, header, filename) => {
  const worksheet = utils.json_to_sheet(rows, { raw: true, origin: 'A6' })
  exportWorksheetToXlsx(worksheet, header, filename)
}

const exportWorksheetToXlsx = (worksheet, header, filename) => {
  const workbook = utils.book_new()
  utils.book_append_sheet(workbook, worksheet, 'Отчёт')
  utils.sheet_add_aoa(worksheet, header, { origin: 'A6' })
  writeFileXLSX(workbook, filename, { ignoreEC: true })
}

const exportReportDate = (worksheet) => {
  let date = [['Дата формирования отчёта: ', format(new Date(), 'dd.MM.yyyy')]]
  utils.sheet_add_aoa(worksheet, date, { origin: 'A2' })
}

const exportReportProject = (worksheet, project) => {
  let date = [['Наименование проекта: ', project]]
  utils.sheet_add_aoa(worksheet, date, { origin: 'A4' })
}
